<template>
    <div class="chart_trans_bar">
        <ul>
            <li v-if="options.x.length>0">
                <label>{{$t("chartTrans.xAxis")}}：</label>
                <a-select dropdownClassName="chart_trans_select-dropdown" :dropdownMatchSelectWidth="false" class="chart_trans_select" size="small" :options="options.x" style="min-width:100px" v-model="x" placeholder="暂无" @change="()=>submit('x')"></a-select>
            </li>
            <li v-if="options.y.length>0">
                <label>{{$t("chartTrans.yAxis")}}：</label><a-select dropdownClassName="chart_trans_select-dropdown" :dropdownMatchSelectWidth="false"   class="chart_trans_select" size="small" :options="options.y" style="min-width:100px" v-model="y" placeholder="暂无" @change="()=>submit('y')"></a-select>
            </li>
            <li v-if="options.series.length>0">
                <label>{{$t("chartTrans.compare")}}：</label><a-select dropdownClassName="chart_trans_select-dropdown" :dropdownMatchSelectWidth="false"  class="chart_trans_select" size="small" :options="options.series" style="min-width:100px" v-model="series" placeholder="暂无" allowClear @change="()=>submit('series')"></a-select>
            </li>
        </ul>
    </div>
</template>

<script>
import {Select} from 'ant-design-vue';
import Vue from 'vue'
Vue.use(Select)

export default {
    props: {
        value: {type: Object, default: () => {}},
        chart: {type: Object, default: () => {}},
        fields: {type:Array, default: () => []},
        datas: {type:Array, default: () => []},
    },
    data() {
        return {
            x: this.chart.x && this.chart.x.id? this.chart.x.id : undefined,
            y: this.chart.y && this.chart.y.id? this.chart.y.id : undefined,
            series: this.chart.series && this.chart.series.id? this.chart.series.id : undefined,
            mark: this.chart.mark
        }
    },
    watch: {
        props: {
            immediate: true,
            handler() {
                this.submit()
            }
        },
    },
    methods: {
        submit(type) {
            if(this.chart.summary_overturn && this.series!=null && (type === 'x' || type === 'series')) {
                let a=type 
                let b=type==='x'?'series':'x'
                for(let k =0; k<this.exclude_options[b].length; k++) {
                    if(this.exclude_options[b][k].value!=this[a]) {
                        this[b] = this.exclude_options[b][k].value
                        break
                    }
                }
            }
            let newData = [], newConfig = {}
            let data_dict = {}
            let x_set = new Set(), series_set = new Set()
            let isNaN = false
            function sorter(a, b) {
                if(typeof(a) == 'number' || typeof(b) == 'number'){
                    return a - b
                } 
                else if(typeof(a)=='string') {   
                    return a.localeCompare(b)
                }
                else if(typeof(b)=='string') {   
                    return b.localeCompare(a)
                }
                return a[id] > b[id] ? -1 : a[id] < b[id] ? 1 : 0
            }
            let x_f = {id: this.x}
            let y_f = {id: this.y}
            if(this.fields) {
                const _x_f = this.fields.find(f=>f.id===this.x)
                if(_x_f) {
                    x_f = {..._x_f}
                }
                
                const _y_f = this.fields.find(f=>f.id===this.y)
                if(_y_f) {
                    y_f = {..._y_f}
                }
            }
            // 分组的情况
            if(this.series!=null) {
                let s_f = {id: this.series, filter:undefined}
                if(this.fields) {
                    if(this.chart.series && this.series===this.chart.series.id) {
                        s_f = {...this.chart.series}
                    }
                    else {
                        const _s_f = this.fields.find(f=>f.id===this.series)
                        if(_s_f) {
                            s_f = {..._s_f, filter:undefined}
                        }
                    }
                }
                this.datas.forEach(row=>{
                    let x = row[this.x], y = row[this.y]==null?0:row[this.y], series = row[this.series]
                    x_set.add(x)
                    if(series!==undefined) {
                        series_set.add(series)
                    }
                    
                    if(data_dict[x]==null) {
                        data_dict[x] = {}
                    }
                    if(data_dict[x][series] == null) {
                        data_dict[x][series] = 0
                    }
                    if(typeof y === 'number') {
                        data_dict[x][series] += y
                    }
                });
                let x_list = this.chart.summary_confsort ? Array.from(x_set) : Array.from(x_set).sort(sorter);
                let series_list = this.chart.summary_confsort ? Array.from(series_set) : Array.from(series_set).sort(sorter);
                x_list.forEach((x)=>{
                    series_list.forEach((s)=>{
                        let row = {}
                        row[this.x] = x
                        row[this.series] = s
                        row[this.y] = data_dict[x][s]
                        newData.push(row)
                    })
                })
                if(this.chart.summary_order){
                    let _s_flag = false
                    if(this.chart.summary_order_series_value && this.chart.summary_order_series_value[this.series]) {
                        let _seriesData = _.filter(newData, row=>row[this.series]===this.chart.summary_order_series_value[this.series]) 
                        if(_seriesData.length > 0) {
                            _seriesData = _.orderBy(_seriesData, [this.y], [this.chart.summary_order])
                            const _rank_dict = {}
                            _seriesData.forEach((row, ri)=>{
                                _rank_dict[row[this.x]] = ri 
                            })
                            newData.forEach(row=>{
                                row['_series_value_rank'] = _rank_dict[row[this.x]]==null?99999:_rank_dict[row[this.x]]
                            })
                            newData = _.orderBy(newData, ['_series_value_rank', this.series, this.y, ], ['asc', 'asc', this.chart.summary_order, ])
                            _s_flag = true
                        }
                        
                    }
                    if(!_s_flag) {
                        newData = _.orderBy(newData, [this.x, this.series, this.y, ], ['asc', 'asc', this.chart.summary_order, ])
                    }
                }
                newConfig = {
                    type: this.chart.type,
                    x: {...this.chart.x, ...x_f},
                    y: {...this.chart.y, ...y_f},
                    series: {...this.chart.series, ...s_f},
                    mark: this.mark,
                }
            }
            else {
                this.datas.forEach(row=>{
                    let x = row[this.x], y = row[this.y]==null?0:row[this.y]
                    x_set.add(x)
                    if(data_dict[x]==null) {
                        data_dict[x] = 0
                    }
                    if(typeof y === 'number') {
                        data_dict[x] += y
                    }
                })
                let x_list = this.chart.summary_confsort ? Array.from(x_set) : Array.from(x_set).sort(sorter);
                x_list.forEach((x)=>{
                    let row = {}
                    row[this.x] = x
                    row[this.y] = data_dict[x]
                    newData.push(row)
                })
                if(this.chart.summary_order){
                    newData = _.orderBy(newData, [this.y, this.x], [this.chart.summary_order, 'asc'])
                }
                newConfig = {
                    type: this.chart.type,
                    x: {...this.chart.x, ...x_f},
                    y: {...this.chart.y, ...y_f},
                    mark: this.mark,
                }
            }
            const _fs=['legend', 'htmllegend', 'tooltip', 'slider', 'label', 'point', 'reverse', 'color', 'summary_tooltip_sort']
            _fs.forEach(f=>{
                if(f in this.chart) {
                    newConfig[f] = this.chart[f]
                }
            })
            if(x_set.size>=1000) {
                this.$message.error("横轴数量太大请选择其他指标")
                return
            }
            else if(x_set.size * series_set.size >= 10000) {
                this.$message.error("对比数量太大请选择其他指标")
                return
            }
            this.$emit('input', {data:newData, config:newConfig})
        }
    },
    computed: {
        props() {
            return {c:this.chart, f:this.fields, d:this.datas}
        },
        exclude_options() {
            let option_dict = {}
            for(let conf of ["x","y", "series"]) {
                let excludes = []
                let exclude_str = this.chart[`exclude_${conf}`]
                if(exclude_str) {
                    excludes = exclude_str.replace(/，/g, ",").split(",").map(e=>e.trim())
                }
                let options = []
                this.fields.forEach((field)=>{
                    if(excludes.indexOf(field.id) < 0 ) {
                        options.push({value:field.id, label:field.title})
                    }
                })
                option_dict[conf] = options
            }
            return option_dict
        },
        options() {
            let option_dict = {}
            for(let conf of ["x","y", "series"]) {
                option_dict[conf] = this.exclude_options[conf].map(field=>{
                    if(this.chart.summary_overturn && (conf==='x' || conf==='series')) {
                        return field
                    }
                    else {
                        let newfield = Object.assign({disabled:[this.x, this.y, this.series].indexOf(field.value) >= 0}, field);
                        return newfield
                    }
                })
            }
            return option_dict
        },
    },
}
</script>
<style lang="less">
.chart_trans_select-dropdown {
.ant-select-dropdown-content .ant-select-dropdown-menu-root {
&::-webkit-scrollbar {
    width: 5px; /*滚动条宽度*/
    height: 5px; /*滚动条高度*/
    background: #f1f1f1;
    margin: 0 5px 0 0;
  }

  /*定义滑块 内阴影+圆角*/
  &::-webkit-scrollbar-thumb {
    border-radius: 3px; /*滚动条的圆角*/
    background-color: #bbb; /*滚动条的背景颜色*/
  }
}
}
</style>
<style scoped lang="less">
.chart_trans_bar {
    display: inline-block;
    vertical-align:middle;
    margin:0 0 10px 0;
    font-weight: normal;
    font-size: 14px;
    ul {
        li {
            display: inline-block;
        }
    }
    label {
        margin: 0 0 0 10px;
    }
}
.chart_trans_select {
    font-size: 12px;

}
</style>